import { gql } from '@apollo/client'

export const ATTEND_EVENT = gql`
    mutation AttendEvent($input: attendEventInput!) {
        attendEvent(input: $input) {
            entity {
                guid
                ... on Event {
                    isAttending
                }
            }
        }
    }
`
